// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"8fcef148","738":"ac2c1952","818":"beb0a3d7"}[chunkId] + ".chunk.js";
};